import { QuoteError } from '~/lib/types/basket-types';
import { useMemo, useState } from 'react';
import { isQuoteDropOff, QuoteFilterOptions } from '~/lib/quotes';
import { QUOTE_API } from '~/lib/constants';
import ServiceSwitcherCore from './service-switcher-core';
import useQuote from '~/hooks/use-quote';
import useBasket from '~/hooks/use-basket';
import usePostcodeRedirect from '~/components/address-details/address/use-postcode-redirect';
import { useTenant } from '@parcel2go/npm-p2g-app';
import { PublicSettings } from '~/lib/ui-serverless-settings';

type Props = {
  errors: QuoteError[];
};

const ServiceUnavailable: React.FC<Props> = ({ errors }) => {
  const [open, setOpen] = useState(true);
  const { item, changeService, id, currentItemId } = useBasket();
  const { quote } = useQuote();
  const { onClick } = usePostcodeRedirect();
  const { settings } = useTenant();

  const defaultFilter: QuoteFilterOptions | undefined = useMemo(
    () =>
      settings[PublicSettings.QUOTES.SERVICEOPTIONSENABLED] === 'true'
        ? ({
            serviceType: isQuoteDropOff(quote) ? 'Drop Off' : 'Collection'
          } as QuoteFilterOptions)
        : undefined,
    [quote, settings]
  );

  return (
    <ServiceSwitcherCore
      intent="INVALID"
      item={item}
      changeService={changeService}
      quoteDefaultFilter={defaultFilter}
      onGetQuote={onClick}
      errorMessages={errors}
      open={open}
      onClose={() => setOpen(false)}
      quoteUrl={`${QUOTE_API}/quote/basket/${id}?itemIds=${currentItemId}&service=`}
      height="75vh"
      dataTestId="problem-service-switcher"
    >
      {/* <P2GBox textAlign="center" p={4} bordered>
        Some Helpful Tips based on the error messages.Did you mean 1kg, not 1000g?
      </P2GBox> */}
    </ServiceSwitcherCore>
  );
};

export default ServiceUnavailable;
